<template>
  <header class="ui-page-header">
    <div class="ui-page-header__text">
      <h1 class="ui-page-header__title">{{ title }}</h1>
      <p v-if="subtitle" class="ui-page-header__subtitle">{{ subtitle }}</p>
    </div>
    <div v-if="$slots.actions" class="ui-page-header__actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script setup>
defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, default: "" },
});
</script>

<style scoped>
.ui-page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--space-4);
  flex-wrap: wrap;
  padding: var(--space-5) var(--space-5) var(--space-4);
  text-align: left;
}
.ui-page-header__title {
  font-size: var(--text-large-title);
  font-weight: var(--weight-bold);
  letter-spacing: -0.02em;
  margin: 0;
}
.ui-page-header__subtitle {
  margin: 4px 0 0;
  font-size: var(--text-callout);
  color: var(--label-secondary);
}
.ui-page-header__actions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}
</style>
